
import { Hero } from './components/Hero';
import { About } from './components/About';
import { News } from './components/News';
import { Event } from './components/Event';
import { Company } from './components/Company';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-black">
      <Hero />
      <About />
      <News />
      <Event />
      <Company />
      <Contact />
      <Footer />
    </div>
  );
}
